import { watch } from "vue";
import { useI18n } from "vue-i18n";

export function setupLocale() {
    const { locale } = useI18n({ useScope: "global" });

    // Get stored locale from localStorage or use browser's language as fallback
    const storedLocale = localStorage.getItem("locale");
    const browserLocale = navigator.language.slice(0, 2); // Get first two chars (e.g., "en", "nl")

    const initialLocale = storedLocale || browserLocale || "en";

    // Set the initial locale
    locale.value = initialLocale;

    // Watch for locale changes and store them in localStorage
    watch(locale, (newLocale) => {
        localStorage.setItem("locale", newLocale); // Persist the new locale
    });

    return locale;
}